import { useMemo } from 'react';
import { useRawAttributes } from '../utils/zustand';

export const useGroupedFieldOptions = () => {
  const { rawAttributes } = useRawAttributes();

  const groupedFieldOptions = useMemo(() => {
    if (!rawAttributes || rawAttributes.length === 0) return [];

    const groups = rawAttributes.reduce((acc, attr) => {
      const { type, typeLabel, metric, label, name } = attr;
      if (!acc[type]) {
        acc[type] = { label: typeLabel, options: [] };
      }
      acc[type].options.push({
        label: `${label} (${name})`,
        value: name,
        metric: metric,
      });
      return acc;
    }, {});

    // Return groups in order: structured, technical, marketing
    const order = ['structured', 'technical', 'marketing'];
    return order.filter((key) => groups[key]).map((key) => groups[key]);
  }, [rawAttributes]);

  return { groupedFieldOptions, rawAttributes };
};
